import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';
import backendFetch from '../api/backendFetchV2';
import { Dataset } from '../types/Dataset';
import { UrlCheckerProps } from './types';

function UrlChecker({
  children,
  isFirstLoad,
  loadDatasetFromUuid,
  setIsFirstLoad,
}: UrlCheckerProps) {
  const params = useParams();
  const navigate = useNavigate();
  const { datasetId } = params;

  const getDatasetByUuid = async (uuid: string) => {
    const {
      account: { name: organizationName, id: organizationId },
      project: { id: projectId },
    } = window.VSS.getWebContext();

    const result = await backendFetch<Dataset>(`/actionable-agile/api/datasets/${uuid}`, {
      method: 'GET',
      headers: {
        'x-55d-org-id': organizationId,
        'x-55d-org-name': organizationName,
        'x-55d-project-id': projectId,
      },
    });

    if (result && result?.data) return result.data;
    return undefined;
  };

  useEffect(() => {
    if (!isFirstLoad) return;
    setIsFirstLoad(false);
    if (!datasetId) {
      navigate('/', { replace: true });
      return;
    }

    if (datasetId === 'example') {
      navigate('/example');
      return;
    }

    getDatasetByUuid(datasetId).then((data) => {
      if (data?.value && typeof data.value !== 'string' && data?.message) {
        const dataset = data.value as Dataset;
        loadDatasetFromUuid(dataset.uuid);
        return;
      }

      // Can't find dataset, navigate back to /example;
      navigate('/', { replace: true });
    });
  }, [datasetId, isFirstLoad]);

  return children;
}

export default UrlChecker;
